<template>
  <div class="flex h-10 w-full items-center justify-between space-x-4">
    <div class="flex items-start gap-2">
      <button class="p-2" @click="toggleEdit">
        <i v-html="$icons.pencil"></i>
      </button>
      <div class="flex flex-col gap-2">
        <input
          class="text-ontick-carbon-900 rounded px-2 py-1 text-2xl font-bold dark:text-gray-300"
          :class="
            editDisabled
              ? 'bg-transparent'
              : 'dark:bg-ontick-graphite-500 ring-ontick-steel-300 ring-2'
          "
          :disabled="editDisabled"
          :value="getData.orderName"
          @input="setData({ prop: 'orderName', value: $event.target.value })"
        />
        <input
          class="text-ontick-carbon-900 rounded px-2 py-1 text-sm dark:text-gray-300"
          :value="getData.orderDescription"
          :class="
            editDisabled
              ? 'bg-transparent'
              : 'dark:bg-ontick-graphite-500 ring-ontick-steel-300 ring-2'
          "
          :disabled="editDisabled"
          @input="
            setData({ prop: 'orderDescription', value: $event.target.value })
          "
        />
      </div>
    </div>
    <div class="flex items-center gap-2">
      <button
        :disabled="isRunning || !getData.method.length"
        @click="$emit('save-params')"
        class="dark:bg-ontick-blue-900 bg-ontick-blue-600 dark:disabled:bg-ontick-steel-500 flex items-center justify-center gap-2 rounded-md p-2 text-sm shadow filter transition-all hover:brightness-110 disabled:cursor-not-allowed disabled:bg-gray-400 disabled:filter-none"
      >
        <i v-html="$icons.pencil" />
        <span class="uppercase"> Salvar </span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ontickSelectComponent from "../../../shared/components/basic/ontick-select.component.vue";

export default {
  components: {
    ontickSelectComponent,
  },

  props: {
    isRunning: {
      type: Boolean,
    },
  },

  computed: {
    ...mapGetters({ getData: "longShort/getData" }),
    saveDisabled() {
      const propByMethod = (method) => {
        switch (method) {
          case "Função linear":
            return !!this.getData.intercept && !!this.getData.slope;
          default:
            return !!this.getData.entryFactor;
        }
      };
      return ![
        !!this.getData.symbol1,
        !!this.getData.symbol2,
        this.getData.volumeType === "FIN_VOLUME"
          ? !!this.getData.symbol1FinVolume
          : !!this.getData.symbol1QtdVolume,
        !!this.getData.operationType,
        !!this.getData.method,
        propByMethod(this.getData.method),
      ].every((item) => item == true);
    },
    title() {
      if (this.$route.params.alg_ord_id) {
        return "Editar ordem";
      }
      return "Criar ordem";
    },
    editDisabled() {
      return this.getData.editDisabled;
    },
  },

  methods: {
    ...mapActions({ setData: "longShort/setData" }),
    toggleEdit() {
      this.setData({
        prop: "editDisabled",
        value: !this.getData.editDisabled,
      });
    },
  },
};
</script>
